/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Agent } from './Agent';
import {
    AgentFromJSON,
    AgentFromJSONTyped,
    AgentToJSON,
} from './Agent';
import type { CoveringAgentId } from './CoveringAgentId';
import {
    CoveringAgentIdFromJSON,
    CoveringAgentIdFromJSONTyped,
    CoveringAgentIdToJSON,
} from './CoveringAgentId';
import type { Email } from './Email';
import {
    EmailFromJSON,
    EmailFromJSONTyped,
    EmailToJSON,
} from './Email';
import type { HumanToken } from './HumanToken';
import {
    HumanTokenFromJSON,
    HumanTokenFromJSONTyped,
    HumanTokenToJSON,
} from './HumanToken';
import type { LicenseNumber } from './LicenseNumber';
import {
    LicenseNumberFromJSON,
    LicenseNumberFromJSONTyped,
    LicenseNumberToJSON,
} from './LicenseNumber';

/**
 * 
 * @export
 * @interface DocumentVersionUploadAgent
 */
export interface DocumentVersionUploadAgent {
    /**
     * 
     * @type {any}
     * @memberof DocumentVersionUploadAgent
     */
    id: any | null;
    /**
     * 
     * @type {any}
     * @memberof DocumentVersionUploadAgent
     */
    firstName: any | null;
    /**
     * 
     * @type {any}
     * @memberof DocumentVersionUploadAgent
     */
    lastName: any | null;
    /**
     * 
     * @type {any}
     * @memberof DocumentVersionUploadAgent
     */
    roles: any | null;
    /**
     * 
     * @type {any}
     * @memberof DocumentVersionUploadAgent
     */
    rbacRoles?: any | null;
    /**
     * 
     * @type {HumanToken}
     * @memberof DocumentVersionUploadAgent
     */
    humanToken?: HumanToken;
    /**
     * 
     * @type {Email}
     * @memberof DocumentVersionUploadAgent
     */
    email?: Email;
    /**
     * 
     * @type {CoveringAgentId}
     * @memberof DocumentVersionUploadAgent
     */
    coveringAgentId?: CoveringAgentId;
    /**
     * 
     * @type {LicenseNumber}
     * @memberof DocumentVersionUploadAgent
     */
    licenseNumber?: LicenseNumber;
}

/**
 * Check if a given object implements the DocumentVersionUploadAgent interface.
 */
export function instanceOfDocumentVersionUploadAgent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "roles" in value;

    return isInstance;
}

export function DocumentVersionUploadAgentFromJSON(json: any): DocumentVersionUploadAgent {
    return DocumentVersionUploadAgentFromJSONTyped(json, false);
}

export function DocumentVersionUploadAgentFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentVersionUploadAgent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['first_name'],
        'lastName': json['last_name'],
        'roles': json['roles'],
        'rbacRoles': !exists(json, 'rbac_roles') ? undefined : json['rbac_roles'],
        'humanToken': !exists(json, 'human_token') ? undefined : HumanTokenFromJSON(json['human_token']),
        'email': !exists(json, 'email') ? undefined : EmailFromJSON(json['email']),
        'coveringAgentId': !exists(json, 'covering_agent_id') ? undefined : CoveringAgentIdFromJSON(json['covering_agent_id']),
        'licenseNumber': !exists(json, 'license_number') ? undefined : LicenseNumberFromJSON(json['license_number']),
    };
}

export function DocumentVersionUploadAgentToJSON(value?: DocumentVersionUploadAgent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.firstName,
        'last_name': value.lastName,
        'roles': value.roles,
        'rbac_roles': value.rbacRoles,
        'human_token': HumanTokenToJSON(value.humanToken),
        'email': EmailToJSON(value.email),
        'covering_agent_id': CoveringAgentIdToJSON(value.coveringAgentId),
        'license_number': LicenseNumberToJSON(value.licenseNumber),
    };
}

